import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X, Phone } from "lucide-react";
import logo from "../assets/images/logo.jpg";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/rooms", label: "Rooms" },
    { path: "/gallery", label: "Gallery" },
    { path: "/nearby", label: "Nearby Places" },
    { path: "/contact", label: "Contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-md">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="shadow-md group-hover:shadow-md transition duration-300">
              <img
                src={logo}
                alt="Ananya Residency Logo"
                className="h-10 w-auto rounded-md object-contain"
              />
            </div>

            <div className="text-2xl font-bold text-[#8B6F47]">
              <span className="font-serif">Ananya</span>
              <span className="text-[#A0826D] ml-2 text-lg font-normal">
                Residency
              </span>
            </div>
          </Link>



          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-[#8B6F47] ${isActive(link.path) ? "text-[#8B6F47] font-semibold" : "text-gray-700"
                  }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Call Button */}
          <div className="hidden md:block">
            <Button
              onClick={() => window.open("tel:+919187501932")}
              className="bg-[#8B6F47] hover:bg-[#6D5838] text-white"
            >
              <Phone className="w-4 h-4 mr-2" />
              Call Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#8B6F47]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 border-t border-gray-200 bg-white shadow-md rounded-b-xl">
            <div className="flex flex-col py-3">

              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`w-full px-5 py-4 text-base font-medium rounded-md transition-colors
            ${isActive(link.path)
                      ? "text-[#8B6F47] bg-[#F5F1EB] font-semibold"
                      : "text-gray-700 hover:bg-[#F5F1EB] hover:text-[#8B6F47]"
                    }`}
                >
                  {link.label}
                </Link>
              ))}

              <div className="px-5 mt-3">
                <Button
                  onClick={() => window.open("tel:+919187501932")}
                  className="w-full py-6 text-base font-semibold bg-[#8B6F47] hover:bg-[#6D5838] text-white rounded-lg shadow-md"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  Call Now
                </Button>
              </div>

            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
